import React from "react";
import { Box } from "@mui/material";

const p = {
	fontFamily: '"Poppins", sans-serif',
	fontSize: 13,
	color: "#444",
	margin: 0,
};
const ul = { paddingLeft: 18, margin: 0, fontFamily: '"Poppins", sans-serif' };

// Template95: Pases NY (guia-ny PassInfo). Contenido desde page (texts, passes).
const Template95 = ({
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const headerText =
		page?.texts?.[0]?.content ?? "Pases turísticos de Nueva York";
	const introText = page?.texts?.[1]?.content;
	const passes =
		Array.isArray(page?.passes) && page.passes.length > 0
			? page.passes
			: [
					{
						nombre: "🎟 New York Pass",
						puntos: [
							"Acceso a +100 atracciones.",
							"Ideal si quieres visitar muchos lugares en pocos días.",
							"Funciona por número de días consecutivos.",
							"Incluye: Empire State, Top of the Rock, Estatua de la Libertad, MoMA...",
						],
					},
					{
						nombre: "🎟 New York Pass Explorer",
						puntos: [
							"Eliges un número de atracciones (2, 3, 5, 7 o 10).",
							"Ideal si quieres ver solo lo más importante.",
							"Flexible: no es necesario usarlo en días consecutivos.",
							"Incluye: Empire State, Top of the Rock, One World Observatory...",
						],
					},
					{
						nombre: "🎟 Sightseeing DAY Pass",
						puntos: [
							"Acceso ilimitado a +150 atracciones durante los días que elijas.",
							"Ideal si quieres visitar mucho en poco tiempo.",
							"Incluye crucero, Bus turístico Hop-on Hop-off, Empire State...",
						],
					},
					{
						nombre: "🎟 Sightseeing FLEX Pass",
						puntos: [
							"Eliges un número de atracciones (2, 3, 5, 7, 10 o 12).",
							"Ideal para viajes tranquilos, sin presión de días.",
							"Flexible: no es necesario usarlo en días consecutivos.",
							"Incluye crucero, Bus turístico Hop-on Hop-off, Empire State...",
						],
					},
				];

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: "#f7f7f7",
				position: "relative",
				fontFamily: fontFamily || '"Poppins", sans-serif',
				"& *": {
					fontFamily: (fontFamily || '"Poppins", sans-serif') + " !important",
				},
			}}
		>
			<div
				data-block-id="header"
				style={{
					backgroundColor: headerBackgroundColor || "#59c3d8",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontFamily: fontFamily || '"Poppins", sans-serif',
					fontSize: "14px",
					fontWeight: 700,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 99999,
				}}
			>
				{headerText}
			</div>
			<div
				style={{
					padding: "0 16px",
					display: "flex",
					flexDirection: "column",
					gap: 16,
				}}
			>
				{introText && (
					<p
						data-block-id="text-1"
						style={{ ...p, fontSize: "13px", color: "#444", marginTop: "10px" }}
					>
						{introText}
					</p>
				)}
				<div data-block-id="text-2" style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
					{passes.map((pase, index) => (
						<div
							key={index}
							style={{
								backgroundColor: "#fff",
								borderRadius: "12px",
								border: "2px solid #e0f7fa",
								padding: "14px",
								fontSize: "13px",
								color: "#444",
								marginBottom: "10px",
							}}
						>
							<strong style={{ fontSize: "14px" }}>{pase.nombre}</strong>
							<ul
								style={{
									...ul,
									marginTop: "8px",
									paddingLeft: "20px",
								}}
							>
								{Array.isArray(pase.puntos) &&
									pase.puntos.map((punto, idx) => <li key={idx}>{punto}</li>)}
							</ul>
						</div>
					))}
				</div>
			</div>
		</Box>
	);
};

export default Template95;
